import * as Yup from "yup";

// form field names
export type TFormFieldNames = "ruleid";

// initial values for the form
export const formInitialValues = {
  ruleid: "",
};

// validation schema for the form
export const YupValidationSchema = Yup.object().shape({
  ruleid: Yup.string()
    .required("Please enter the rule id")
    .matches(/^[a-z0-9\-_]+$/, 'Only lowercase characters, numbers, hyphens, and underscores are allowed')
});
